const getCheckoutUrlByProvider = (state) => (provider) => {
  return state.purchase[provider].checkout.url
}

export default {
  getCheckoutUrlByProvider
}
